// extracted by mini-css-extract-plugin
module.exports = {"title":"_6bf55ce5dc--title--a8s4I","subtitle":"_6bf55ce5dc--subtitle--bVMRl","counter":"_6bf55ce5dc--counter--rEWJp","projects-link":"_6bf55ce5dc--projects-link--H8Qcv"};